import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@spartalabs/pdc-core';
import {
  endPortalSession,
  hasCurrentPortalPermissionsSchema,
} from 'utils/endPortalSession';

/**
 * Força novo login quando a sessão persistida usa schema de permissões antigo
 * (ex.: relatórios visíveis sem permissão PDV após alteração no gestor).
 */
export const PortalSessionGuard = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const checkedRef = useRef(false);

  const token = useAppSelector(state => state.authSlicer.user.token);
  const refreshToken = useAppSelector(state => state.authSlicer.user.refreshToken);

  useEffect(() => {
    if (checkedRef.current || !token) return;
    checkedRef.current = true;

    if (hasCurrentPortalPermissionsSchema()) return;

    void (async () => {
      await endPortalSession(dispatch, token, refreshToken);
      navigate('/login', { replace: true });
    })();
  }, [dispatch, navigate, refreshToken, token]);

  return null;
};
